import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { priceRangeLabel } from '@/app/common/filters/types/range/priceRangeLabel.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { FilterBadgeContent } from '@/app/common/filters/surfaces/badges/FilterBadgeContent.tsx';
import type { FilterDataRange } from '@/app/common/filters/core/filtersTypes.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { usePriceFilterScale, scaleRangeData } from '@/app/common/filters/surfaces/forms/custom/usePriceFilterScale.ts';

export const FilterRangeBadge = ({ filter, isLoading, handleFilterChanged }: FilterComponentProps) => {
  const filterData = filter.data as FilterDataRange;

  const { localization } = useFiltersUiData();
  const { t } = useTranslation();
  const { scale } = usePriceFilterScale(filter.name);

  const handleFilterClicked = () => {
    const updatedFilter = {
      ...filter,
      data: {
        ...filterData,
        value: {
          min: filterData.default.min,
          max: filterData.default.max,
        },
      },
    };
    handleFilterChanged([updatedFilter]);
  };

  // Badge text shows the selected range in display space (total when toggled).
  const label = priceRangeLabel(
    { ...filter, data: scaleRangeData(filterData, scale) },
    { t, localization, unbounded: true }
  );

  return <FilterBadgeContent label={label} handleFilterClicked={handleFilterClicked} isLoading={isLoading} />;
};
